import React, { useEffect, useState } from 'react'
import TableWrapper from '../../../../component/TableWrapper'
import { Icons } from '../../../../assets'
import NormalSelect from '../../../../component/NormalSelect'
import { useDispatch } from 'react-redux'
import { saveLoadingState } from '../../../../redux/reducers/loadingSlice'
import Exported from '../../../../service/endpoints'
import request from '../../../../service'
import { Toast } from '../../../../service/toast'
import moment from 'moment'
import { StatusCode } from '../../../../helpers'
import ConfirmationModal from '../../../../modalComponents/ConfirmationModal'
import ModalDropdown from '../../../../component/ModalDropdown'
import CloseIcon from '@mui/icons-material/Close';
import { FormProvider, useForm } from 'react-hook-form';

import classes from "./style.module.scss"
import Button from '../../../../component/Button'
import InputBox from '../../../../component/InputBox'

const ContactTable = ({ handleView, searchInput = '', getUserList, getContactCount, page, setPage, sortConfig, setSortConfig, isLoading, setisLoading, userList, setUserList  }) => {
    const [selectedId, setSelectedId] = useState(null);
    const [confirmationModal, setConfirmationModal] = useState(false)
    const [isOpen, setIsOpen] = useState(false)
    const [prodId, setProdId] = useState()
    const dispatch = useDispatch()
    const formMethods = useForm({
        mode: 'onSubmit',
    });
    const {
        handleSubmit,
        formState: { errors },
        register,
        trigger,
        resetField,
    } = formMethods;

    const statusOptions = [
        { label: "Open", value: "1" },
        { label: "In Progress", value: "2" },
        { label: "Closed", value: "3" },
    ];
    const tableHeader = [
        { label: "Issue ID", sortable: "id" },
        { label: "Customer Name", sortable: "firstName" },
        { label: "Customer Type", sortable: "userRole" },
        { label: "Subject", sortable: "subject" },
        { label: "Date Submitted" },
        { label: "Status" },
        { label: "Actions" },
    ]


    const handleDelete = (itemId) => {
        setConfirmationModal(true)
        setSelectedId(itemId)
    }

    const handleConfirmDelete = async () => {
        dispatch(saveLoadingState(true))
        let url = `${Exported.Endpoints.getContactFormByID}/${selectedId}`
        const requestData = {
            id: selectedId,
        }
        await request({
            url: url,
            method: Exported.APIMethods.DELETE,
            data: requestData
        }).then(async (res) => {
            if (res?.data?.status) {
                await getUserList()
                await getContactCount()
                Toast({
                    type: 'success',
                    message: 'Deleted successfully!'
                })
            }
        }).catch((err) => {
            console.log(err, "err")
            Toast({
                type: 'error',
                message: 'Unable to process the request!..'
            })
        })
        dispatch(saveLoadingState(false))
        handleDeleteClose()
    }

    const handleDeleteClose = () => {
        setSelectedId(null)
        setConfirmationModal(false)
    }

    const handleStatus = (id) => {
        setProdId(id)
        setIsOpen(true);

    }

    const closePopUp = () => {
        setIsOpen(false)
    }

    const onSubmit = async (data) => {
        dispatch(saveLoadingState(true))
        let url = `${Exported.Endpoints.getContactFormByID}/${prodId}`

        const requestData = {
            status: 3,
            admin_comment: data.reason
        }
        await request({
            url: url,
            method: Exported.APIMethods.PUT,
            data: requestData
        }).then(async (res) => {
            if (res?.data?.status) {
                await getUserList()
                await getContactCount()
                setIsOpen(false)
                resetField('reason')
                Toast({
                    type: 'success',
                    message: 'Status updated successfully'
                })
            }
        }).catch((err) => {
            console.log(err, "err")
            Toast({
                type: 'error',
                message: 'Unable to process the request!..'
            })
        })
        dispatch(saveLoadingState(false))
    }

    return (
        <>
            <div>
                <TableWrapper
                    headerDetails={tableHeader}
                    isLoading={isLoading}
                    listLength={userList?.result?.length || []}
                    pageMeta={userList.pageMeta}
                    handlePageChange={setPage}
                    sortConfig={sortConfig}
                    setSortConfig={setSortConfig}
                >
                    {userList?.result?.map((data, index) => (
                        <tr key={index}>
                            <td>
                                <div className='pl-3'>{data.id}</div></td>
                            <td>{data.user?.username}</td>
                            <td>{data.user?.role?.name}</td>
                            <td>{data.subject}</td>
                            <td>{data.createdAt ? moment(data.createdAt)?.format('DD MMM YYYY') : '-'}</td>
                            {/* <td>
                                <NormalSelect
                                    className={`w-[100%] p-0`}
                                    list={statusOptions}
                                    value={StatusCode[data.status]}
                                    handleChange={(e) => e != data?.status ? handleStatus(data?.id, e) : null}
                                    highLight
                                    highLightColor={
                                        data.status == "1" ? "#FC0000" :
                                            data.status == "2" ? "#CE8704" :
                                                data.status == "3" ? "#01CB46" : ""
                                    }
                                    disabled={data.status == "3"}
                                    placeholder="Status"
                                />
                            </td> */}
                            <td className=" px-3 mx-auto text-center">
                                <div className='' style={{
                                    color: data.status === 3 ? '#01CB46' :
                                        data.status === 1 ? '#FC0000' : data.status === 2 ? '#D99E27' : '#000000'
                                }}>
                                    {data.status === 3 ? 'Completed' :
                                        data.status === 1 ? 'Open' : data.status === 2 ? 'In Progress' : ""}
                                </div>
                            </td>
                            <td className=" px-3 mx-auto text-center action-button">
                                <div className='flex items-center justify-center'>
                                    <img src={Icons.eye} alt='View' className='cursor-pointer w-[20px] h-[20px]' onClick={() => handleView(data.id)} />
                                    <img src={Icons.checked} alt='Done' className='cursor-pointer w-[22px] h-[22px] mx-2' style={{ opacity: data.status == '3' ? '0.5' : '1', cursor: data.status == '3' ? ' default ' : 'pointer' }} onClick={() => data.status == '3' ? null : handleStatus(data?.id, 3)} />
                                    {/* <img src={Icons.closeCircle} alt='Delete' className='w-[20px] h-[20px]' style={{ opacity: data.status == '3' ? '0.5' : '1', cursor: data.status == '3' ? 'default' : 'pointer' }} onClick={() => data.status == '3' ? null : handleDelete(data?.id)} /> */}
                                </div>
                            </td>
                        </tr>
                    ))}
                </TableWrapper>
            </div>
            {confirmationModal ?
                <ConfirmationModal
                    isOpen={confirmationModal}
                    handleSuccess={handleConfirmDelete}
                    closePopUp={handleDeleteClose}
                    warningText={'Confirmation'}
                    modalText={'Are you sure you want to delete?'}
                    confirmText={'Yes'}
                    cancelText={'No'}
                />
                : null
            }
            {isOpen ? <ModalDropdown isOpen={isOpen} closePopUp={closePopUp}>
                <div className={`${classes.reasonModalWrapper}`}>
                    <div className={`${classes.modalHeader} flex items-center justify-between`}>
                        <div className={`${classes.modalTitle}`}>Add Internal Comment</div>
                        <div className={`${classes.modalCloser}`}>
                            <CloseIcon onClick={() => closePopUp()} />
                        </div>
                    </div>
                    <div className={`${classes.reasonFormContainer}`}>
                        <FormProvider {...formMethods}>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className={`${classes.formGroup}`}>

                                </div>
                                <div className={`${classes.formField}`}>
                                    <InputBox
                                        label={"Comment"}
                                        className={`w-[100%] ${classes.notesInput}`}
                                        name={"reason"}
                                        type={"textarea"}
                                        {...register("reason", {
                                            required: true,
                                        })}
                                        error={errors.reason}
                                        messages={{
                                            required: "Comment is required",
                                        }}
                                    />
                                </div>
                                <div className='flex justify-end'>
                                    <Button text={"Submit"} className={`w-[100%] my-4`} smallBtn />
                                </div>
                            </form>
                        </FormProvider>
                    </div>
                </div>
            </ModalDropdown> : null}
        </>
    )
}

export default ContactTable